import { createApiRef } from '@backstage/core-plugin-api';
import { pluginConfig } from '../config.esm.js';

const S3ApiRef = createApiRef({
  id: `plugin.${pluginConfig.pluginId}.service`
});

export { S3ApiRef };
//# sourceMappingURL=awsS3ApiRef.esm.js.map
